/**
 * Admin Cleanup 0 — System → Tekniskt läge.
 * Samlingsyta för tekniska verktyg (Blueprints/rå JSON/runtime/diff/
 * actions, runtime-monitor, LLM-diagnostik, optimering) så att de inte
 * ligger i den normala arbetsnavigationen.
 */
import { Link } from "react-router-dom";
import { Activity, ShieldAlert, Wand2, Wrench } from "lucide-react";

const TOOLS = [
  {
    to: "/admin/blueprints",
    testid: "teknik-blueprints",
    icon: ShieldAlert,
    title: "Agent Blueprints",
    desc: "Rå JSON, runtime-förhandsvisning, diff, actions och replay per kund.",
  },
  {
    to: "/admin/runtime-events",
    testid: "teknik-runtime",
    icon: Activity,
    title: "Runtime monitor",
    desc: "Runtimeevents och observability i realtid.",
  },
  {
    to: "/admin/llm-diagnostik",
    testid: "teknik-llm",
    icon: Activity,
    title: "LLM-diagnostik",
    desc: "Modellanrop, fel och latens.",
  },
  {
    to: "/admin/optimering",
    testid: "teknik-optimering",
    icon: Wand2,
    title: "Optimering",
    desc: "Optimeringscenter för agenter.",
  },
];

export default function TechnicalMode() {
  return (
    <div className="space-y-5" data-testid="technical-mode">
      <div>
        <h1 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Wrench className="w-5 h-5" /> Tekniskt läge
        </h1>
        <p className="text-xs text-gray-500 mt-1 max-w-2xl">
          Interna tekniska verktyg. Det dagliga kundarbetet sker i{" "}
          <Link to="/admin/clients" className="text-[#255E69] hover:underline">Kunder → Kund 360</Link>.
        </p>
      </div>
      <div className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800">
        Ändringar här påverkar kundernas AI-agenter direkt. Använd med omdöme.
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {TOOLS.map((t) => {
          const Icon = t.icon;
          return (
            <Link key={t.to} to={t.to} data-testid={t.testid} className="bg-white border border-gray-200 rounded-xl p-5 hover:border-[#255E69] transition-colors block">
              <h3 className="font-semibold text-gray-900 flex items-center gap-2">
                <Icon className="w-4 h-4 text-gray-400" /> {t.title}
              </h3>
              <p className="text-xs text-gray-500 mt-1">{t.desc}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
